import React from "react";
import some from "lodash/some";
import radium from "radium";
import cn from "classnames";
import Checkbox from "../../../pois/components/form/checkbox";
import MoreLink from "../../../pois/components/moreLink";
import ModalComponent from "../modal";
import Range from "../../../pois/components/form/range";

const _ = { some };

@radium
class Filter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
      selectNone: true,
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.filterList = this.filterList.bind(this);
    this.selectNone = this.selectNone.bind(this);
    this.changeRange = this.changeRange.bind(this);
    this.renderCheckbox = this.renderCheckbox.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    const selectNone = _.some(nextProps.filters, f => f.checked);

    this.setState({
      selectNone,
    });
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }
  closeModal() {
    this.setState({ modalIsOpen: false });
  }
  selectNone() {
    if (this.props.onSelectNone) {
      this.props.onSelectNone();
    }
  }
  filterList({ name, checked, value }) {
    if (this.props.onChange) {
      this.props.onChange({ name, checked, value });
    }
  }
  changeRange(hoursArray) {
    if (this.props.changeRange) {
      this.props.changeRange(hoursArray);
    }
  }
  renderCheckbox(filter, index, size, style) {
    return (
      <Checkbox
        name={filter.name}
        value={filter.value}
        id={`${filter.name}-${index}`}
        key={`${filter.name}-${index}`}
        size={size}
        onClick={this.filterList}
        checked={filter.checked}
        style={style}
      />
    );
  }
  renderCheckboxInColumn(filter, index, size) {
    return (
      <div key={index} style={{ marginTop: "10px" }}>
        {this.renderCheckbox(filter, index, size)}
      </div>
    );
  }
  render() {
    const { filters, type, truncate, columns, limit, noMargin, modifier } = this.props;
    const truncatedFilters = filters.filter((filter, index) => index < limit);
    const filterLayout = {
      1: "full",
      2: "half",
      3: "third",
    };

    return (
      <div
        className={cn(
          "Filter",
          modifier && `Filter--${modifier}`
        )}
      >
        {type === "checkbox" &&
          <div className={!noMargin ? "Filter-checkbox-container" : ""}>
            <div className="Filter-checkbox">
              {truncate &&
                truncatedFilters.map((filter, index) => (
                  this.renderCheckbox(
                    filter,
                    index,
                    filterLayout[columns],
                    !noMargin && {
                      marginTop: `${(10 / 13)}em`,
                    }
                  )
                ))
              }

              {!truncate &&
                filters.map((filter, index) => (
                  this.renderCheckbox(filter, index, filterLayout[columns])
                ))
              }
            </div>
            {truncate &&
              <div className="Filter-more">
                {filters.length > limit && (
                  <div className="Filter-modal">
                    <MoreLink
                      size="small"
                      onClick={this.openModal}
                      style={{ marginTop: "28px" }}
                      caps
                    >
                      More Categories
                    </MoreLink>
                    <ModalComponent
                      isOpen={this.state.modalIsOpen}
                      selectNone={this.state.selectNone}
                      onSelectNone={this.selectNone}
                      filterList={this.filterList}
                      closeModal={this.closeModal}
                      title="Type"
                    >
                      <div style={{ columnCount: 3 }}>
                        {filters.slice(0)
                          .sort((a, b) => {
                            if (a.name < b.name) return -1;
                            else if (a.name > b.name) return 1;
                            return 0;
                          })
                          .map((filter, index) =>
                          (
                            this.renderCheckboxInColumn(filter, index, "full")
                          )
                        )}
                      </div>
                    </ModalComponent>
                  </div>
                  )
                }
              </div>
            }

          </div>
        }
        {type === "slider" &&
          <Range onAfterChange={this.changeRange} {...this.props} />
        }
      </div>
    );
  }
}

Filter.propTypes = {
  /**
  * Array of subtypes to filter list
  */
  filters: React.PropTypes.array,

  /**
  * String of which type of filter
  */
  type: React.PropTypes.oneOf([
    "checkbox",
    "slider",
    "datepicker",
  ]),

  /**
  * Boolean to limit filters
  */
  truncate: React.PropTypes.bool,

  columns: React.PropTypes.oneOf([
    1,
    2,
    3,
  ]),

  onChange: React.PropTypes.func,

  changeRange: React.PropTypes.func,

  onSelectNone: React.PropTypes.func,

  /**
   * How many checkboxes to show; the remaining will be shown in a modal
   */
  limit: React.PropTypes.number,

  noMargin: React.PropTypes.bool,

  /**
   * A modifier classname to be appended to base classname; usually this is used
   * as a layout styling hook within an SCSS file, so be careful when removing
   */
  modifier: React.PropTypes.string,
};

Filter.defaultProps = {
  filters: [],

  type: "checkbox",

  truncate: true,

  columns: 2,

  onChange: null,

  changeRange: null,

  onSelectNone: null,

  limit: 100,

  modifier: "",
};

export default Filter;



// WEBPACK FOOTER //
// ./assets/list/components/filter/index.jsx